<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <h1 class="title-default">Integração</h1>
        <p class="welcome-message">Bem vindo ao seu módulo <span class="display-name">Integração</span>! Aqui você pode
            encontra as configurações e logs das suas integrações.</p>
        <h2>Gerência de acesso:</h2>
        <p>
            Para acessar qualquer Endpoint e Webhook é necessário a criação de uma chave de acesso, na aba "Chaves de
            Acesso", onde deve ser vinculado um usuário integrador. A Chave de Acesso é um GUID que deve ser passado
            sempre
            que
            requisitado.
        </p>

        <h2>Gerência de log:</h2>
        <p>Todos os logs da integração são salvos, e podem ser consultados na aba "Logs de Integração".</p>

        <h2>Integração Pelas API's:</h2>
        <p>É possível consumir os Endpoints de Integração da ATS, com base na documentação do Postman, linkado abaixo.
            Sempre enviando a Chave de Acesso quando requisitado.
        </p>

        <h2>Integração pelo Webhook:</h2>
        <p>É possível consumir os Webhooks da ATS, que devem ser gerenciados na aba "Webhook".
            Não pode ser cadastrado multiplos Webhooks do mesmo tipo.
        </p>

        <h2>Documentação das APIs:</h2>
        <p>O <a routerLink="/documentacao-publica" target="_blank" rel="noopener noreferrer">link</a> de acesso à
            documentação das APIS de Integração.</p>

        <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
    </div>
</div>